import {
  PageComponent,
  PageOption,
} from "../../constants/page-components.mapping";
import useRenderPageComponent from "../../hooks/render-page-component.hook";

type PageComponentsWrapperProps<P extends PageOption> = {
  children: React.ReactNode;
  page: P;
  component: PageComponent<P>;
  trackTypeId?: number;
  loadingComponent?: React.ReactNode;
  isLoading?: boolean;
  fallbackComponent?: React.ReactNode;
};

export default function PageComponentsWrapper({
  children,
  page,
  trackTypeId,
  component,
  loadingComponent = null,
  isLoading: externalLoading = false,
  fallbackComponent = null,
}: PageComponentsWrapperProps<PageOption>) {
  const { isLoading, renderedComponent } = useRenderPageComponent({
    page,
    component,
    trackTypeId,
  });

  const isLoadingComponent = externalLoading || isLoading;

  if (isLoadingComponent && loadingComponent) {
    return loadingComponent;
  }

  if (!renderedComponent) {
    return fallbackComponent;
  }

  return children;
}
